import type { SVGProps } from "react";
export function InfoCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <g clipRule="evenodd" fill="currentColor" fillRule="evenodd">
        <path d="m6.61115 7.11115c0-.27614.22386-.5.5-.5h.44445c.5216 0 .94444.42284.94444.94445v2.22222c0 .21478.17411.38888.38889.38888h.44444c.27615 0 .5.2239.5.5s-.22385.5-.5.5h-.44444c-.76706 0-1.38889-.6218-1.38889-1.38888v-2.16667h-.38889c-.27614 0-.5-.22386-.5-.5z" />
        <path d="m7.0556 5.11115c0-.39887.32335-.72222.72222-.72222s.72222.32335.72222.72222-.32335.72222-.72222.72222-.72222-.32335-.72222-.72222z" />
        <path d="m.833374 8.00004c0-3.95804 3.208626-7.166666 7.166666-7.166666 3.95806 0 7.16666 3.208626 7.16666 7.166666 0 3.95806-3.2086 7.16666-7.16666 7.16666-3.95804 0-7.166666-3.2086-7.166666-7.16666zm7.166666-6.16667c-3.40576 0-6.16667 2.76091-6.16667 6.16667s2.76091 6.16666 6.16667 6.16666 6.16666-2.7609 6.16666-6.16666-2.7609-6.16667-6.16666-6.16667z" />
      </g>
    </svg>
  );
}
